import axios from 'axios';
import { API } from '../config/apiConfig';

class ApiService {
  constructor() {
    this.token = null;
    this.client = axios.create({
      baseURL: API.baseUrl,
      headers: { 'Content-Type': 'application/json' },
    });
    this.client.interceptors.request.use((config) => {
      if (this.token) {
        config.headers.Authorization = `Bearer ${this.token}`;
      }
      return config;
    });
  }

  setToken(token) {
    this.token = token;
  }

  clearToken() {
    this.token = null;
  }

  async register(username, phone, password, displayName) {
    const res = await this.client.post('/api/auth/register', {
      username,
      phone,
      password,
      displayName,
    });
    return res.data;
  }

  async login(phone, password) {
    const res = await this.client.post('/api/auth/login', { phone, password });
    return res.data;
  }

  async getMe() {
    const res = await this.client.get('/api/users/me');
    return res.data;
  }

  async searchUsers(query) {
    const res = await this.client.get(`/api/users/search?q=${encodeURIComponent(query)}`);
    return res.data;
  }

  async getUser(id) {
    const res = await this.client.get(`/api/users/${id}`);
    return res.data;
  }

  async getConversations() {
    const res = await this.client.get('/api/conversations');
    return res.data;
  }

  async createConversation(participantIds, isGroup = false, groupName = null) {
    const res = await this.client.post('/api/conversations', {
      participants: participantIds,
      isGroup,
      groupName,
    });
    return res.data;
  }

  async getConversation(id) {
    const res = await this.client.get(`/api/conversations/${id}`);
    return res.data;
  }

  async getMessages(conversationId, limit = 50, before = null) {
    let url = `/api/conversations/${conversationId}/messages?limit=${limit}`;
    if (before) url += `&before=${encodeURIComponent(before)}`;
    const res = await this.client.get(url);
    return res.data;
  }

  async testPush() {
    const res = await this.client.post('/api/users/test-push', {});
    return res.data;
  }
}

const apiService = new ApiService();
export default apiService;
